import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=019cfff7&scoped=true"
import script from "./pdfViewer.vue?vue&type=script&lang=js"
export * from "./pdfViewer.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/examManual/pdfViewer.css?vue&type=style&index=0&id=019cfff7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019cfff7",
  null
  
)

export default component.exports